const FS = {};

export { FS };
